// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RWIw2","top":"styles_top__+3w9t","choiceSeats":"styles_choiceSeats__YL1Pu","seats":"styles_seats__exkOw","row":"styles_row__m6z8O"};